// Image map on stories: hovering a polygon shows the matching section
// (data-who = its id) and hides the title; leaving the map shows the title again.
export default function imagemap() {
    document.querySelectorAll('.imagemap-poly').forEach((polygon) => {
        const section = document.getElementById(polygon.dataset.who);
        polygon.addEventListener('mouseenter', () => {
            section?.classList.remove('hide');
            document.querySelectorAll('.imagemap-title').forEach((t) => t.classList.add('hide'));
        });
        polygon.addEventListener('mouseleave', () => section?.classList.add('hide'));
    });

    document.getElementById('imagemap')?.addEventListener('mouseout', () => {
        document.querySelectorAll('.imagemap-section').forEach((s) => s.classList.add('hide'));
        document.querySelectorAll('.imagemap-title').forEach((t) => t.classList.remove('hide'));
    });
}
